import { createSlice } from '@reduxjs/toolkit';

import { getPaymentSystemURL } from './payment.middleware';
import { logout } from '../auth/auth-middleware';

type Props = {
    url: string | null;
    error: string | null;
    isLoading: boolean;
};

const initialState: Props = {
    url: null,
    error: null,
    isLoading: false,
};

export const paymentSlice = createSlice({
    name: 'app/stripe',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPaymentSystemURL.fulfilled, (state, action) => {
                state.url = action.payload.data.url;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getPaymentSystemURL.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPaymentSystemURL.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.url = null;
                state.error = null;
                state.isLoading = false;
            });
    },
});

export default paymentSlice.reducer;
